/* eslint-disable max-len */
import styled from 'styled-components';
import { Box } from '../Box';

export const Row = styled(Box)({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row'
});
